import React from 'react';
import PropTypes from 'prop-types';
import { css } from '@bd/bdui-styles/emotion';
import { get } from 'lodash';
import withData from '@bd/bdcore-data';
import { SanitizeHtml } from '@bd/bdcore-utilities';
import ContentBanner from '../../components/ContentBanner';
import Results from './Results';
// import AreaContent from './AreaContent';
import { typography } from '../../styles';

const styles = css`
  width: 100%;
  position: relative;
  z-index: 0;
  .Builders_sectionHead {
    font-family: ${typography.SerifHead};
    font-weight: bold;
    letter-spacing: 0.62px;
    font-style: italic;
    margin-bottom: 0.625em;
  }
  .SectionBuilder_descriptionHead{
    text-align: center;
  }
  .SectionBuilder_descriptionHead {
    display: block;
    margin-bottom: 0.4em;
  }
  .HOADues_wrapper{
    text-align: center;
    color:white;
  }
  .HoaDue_imageWrapper {
    display: flex;
    justify-content: center;
  }
  .HoaDues_body {
    img {
      width: 100%;
      @media(min-width: 500px) {
        width: auto;
        max-height: 600px;
      }
    }
  }
  .Btn{max-width: 340px; margin: auto;}
`;


const sortOptions = [
  { title: 'Name', field: 'name' },
  { title: 'City', field: 'address.addressLocality' },
  { title: 'Price', field: 'priceLow' },
];


class CommunityResultsWrapper extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      sort: sortOptions[2],
    };
  }
  render() {
    const { communities, widget } = this.props;
    const { sort } = this.state;
    const nonSoldOutComs = communities.filter(coms => coms.status !== 'Sold Out');
    const soldOutComs = communities.filter(coms => coms.status === 'Sold Out');
    return (
      <main className={styles}>
        <div className="container CommunityResultsWrapper">
          <h3 className="Builders_sectionHead SectionBuilder_descriptionHead GoldText mt-5 mb-4">Available New Construction Neighborhoods</h3>
          <Results sort={sort} communityList={nonSoldOutComs} />
          <ContentBanner
            lead={get(widget, 'description')}
          />
          {soldOutComs &&
            <div>
              <h3 className="Builders_sectionHead SectionBuilder_descriptionHead GoldText mt-5 mb-4">Completed Neighborhoods</h3>
              <Results sort={sort} communityList={soldOutComs} isSold />
            </div>
          }
          {widget.hoa_dues &&
            <div className="HOADues_wrapper">
              <h3 className="Builders_sectionHead SectionBuilder_descriptionHead GoldText mt-5 mb-3">HOA Dues</h3>
              <div className="HoaDues_body" dangerouslySetInnerHTML={SanitizeHtml(widget.hoa_dues)} />
            </div>
          }
          {widget.hoa_pdf &&
            <a href={widget.hoa_pdf.contentUrl} className="Btn Gold" target="_blank" rel="noopener noreferrer">Homeowner Annual Dues</a>
          }
        </div>
      </main>
    );
  }
}

CommunityResultsWrapper.propTypes = {
  communities: PropTypes.arrayOf(PropTypes.object).isRequired,
  widget: PropTypes.object.isRequired,
};


export default withData({
  communities: true,
  widget: 'communities',
})(CommunityResultsWrapper);



// WEBPACK FOOTER //
// ./src/pages/Communities/ResultsWrapper.js